import React, { useEffect, useState } from "react";
import ReportLogo from "../assets/SVGs/Report/ReportLogo";
import PrintReport from "../assets/SVGs/Report/PrintReport";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { MembershipAPI } from "../api/membership";
import Loader from "../componets/Loader";
import dayjs from "dayjs";

const ActiveMemberRoster = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const fetch = async () => {
    setIsLoading(true);
    try {
      const response = await MembershipAPI.getMembers("active");
      setData(response.items);
    } catch (e) {
      console.error("Error during fetching report", e);
      const status = e.response?.status;
      if (status === 401) {
        navigate("/login");
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePrint = () => {
    window.print(); // Opens the browser's print dialog
  };

  return isLoading ? (
    <Loader height="100vh" />
  ) : (
    <div className="report-section flex flex-col gap-16">
      <header className="report-header flex align-center justify-between flex-col gap-16">
        <ReportLogo width={122} height={50} />
        <div className="header-section flex align-center justify-between flex-col">
          <h1 className="header-title">Active Member Roster</h1>
          <IconButton
            sx={{
              border: "1px solid #AEBBCB",
              "@media print": {
                display: "none", // Hides the button during print
              },
            }}
            onClick={handlePrint}
            className="no-print"
          >
            <PrintReport className="no-print" />
          </IconButton>
        </div>
      </header>

      <div className="customTable active-member-roster-table">
        <table>
          <thead>
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Company</th>
              <th>Email Address</th>
              <th>Phone No.</th>
              <th>Chair</th>
              <th>Date Started</th>
              <th>Expiration</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={row.id} className={index % 2 === 0 ? "" : "bg-gray"}>
                <td>{row.first_name}</td>
                <td>{row.last_name}</td>
                <td>{row.company}</td>
                <td>{row.email_address}</td>
                <td>{row.phone_number}</td>
                <td>{row.chair}</td>
                <td>{dayjs(row.date_started)?.format("MM/DD/YYYY")}</td>
                <td>
                  {dayjs(row.membership_expiration_date)?.format("MM/DD/YYYY")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ActiveMemberRoster;
